/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Student_DescInputs */

const en_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for students and early-career seekers.`)
};

const de_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt für Studenten und Berufseinsteiger.`)
};

const fr_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfait pour les étudiants et les chercheurs en début de carrière.`)
};

const es_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para estudiantes y buscadores de empleo en las primeras etapas de su carrera.`)
};

const it_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfetto per studenti e cercatori di lavoro all'inizio della carriera.`)
};

const nl_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect voor studenten en beginnende sollicitanten.`)
};

const pl_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealne dla studentów i osób na początku kariery.`)
};

const fi_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen opiskelijoille ja varhaisurakoitsijoille.`)
};

const da_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt til studerende og jobsøgere tidligt i karrieren.`)
};

const sv_pricing_plan_student_desc = /** @type {(inputs: Pricing_Plan_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt för studenter och tidiga karriärsökare.`)
};

/**
* | output |
* | --- |
* | "Perfect for students and early-career seekers." |
*
* @param {Pricing_Plan_Student_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_student_desc = /** @type {((inputs?: Pricing_Plan_Student_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Student_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_student_desc(inputs)
	if (locale === "fr") return fr_pricing_plan_student_desc(inputs)
	if (locale === "es") return es_pricing_plan_student_desc(inputs)
	if (locale === "it") return it_pricing_plan_student_desc(inputs)
	if (locale === "nl") return nl_pricing_plan_student_desc(inputs)
	if (locale === "pl") return pl_pricing_plan_student_desc(inputs)
	if (locale === "fi") return fi_pricing_plan_student_desc(inputs)
	if (locale === "da") return da_pricing_plan_student_desc(inputs)
	if (locale === "sv") return sv_pricing_plan_student_desc(inputs)
	return en_pricing_plan_student_desc(inputs)
});